import { render, staticRenderFns } from "./orderNxshenpi.vue?vue&type=template&id=2f1679b7&scoped=true"
import script from "./orderNxshenpi.vue?vue&type=script&lang=js"
export * from "./orderNxshenpi.vue?vue&type=script&lang=js"
import style0 from "./orderNxshenpi.vue?vue&type=style&index=0&id=2f1679b7&prod&scoped=true&lang=css"
import style1 from "./orderNxshenpi.vue?vue&type=style&index=1&id=2f1679b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1679b7",
  null
  
)

export default component.exports